import { Iconify } from "./Iconify";

export const Loading = ({
  centered,
  size,
}: {
  centered?: boolean;
  size: number;
}) => {
  if (centered) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Iconify icon="line-md:loading-twotone-loop" width={size} />
      </div>
    );
  }
  return <Iconify icon="line-md:loading-twotone-loop" width={size} />;
};
